// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__LOXo0","bigColWidth":"Table_bigColWidth__2E58a","biggerColWidth":"Table_biggerColWidth__1ybaY","row":"Table_row__3e2Aa","col":"Table_col__1-e_o"};